import {StoreAccountContext} from "./context"

export const StoreAccountProvider =  StoreAccountContext.Provider